import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import FrankLogoSvg from '@src/svgs/frank-logo-new.svg';
import { CircularLoading, Size } from '../CircularLoading';
import './styles.scss';

export const CircularLoadingIcon = ({ size, spinnerClassName, iconClassName, src }) => (
  <CircularLoading className={spinnerClassName} size={size}>
    <Svg className={classnames('fr-circular-loading-icon__icon', iconClassName)} src={src} />
  </CircularLoading>
);

CircularLoadingIcon.propTypes = {
  iconClassName: PropTypes.string,
  size: PropTypes.oneOf(Object.values(Size)),
  spinnerClassName: PropTypes.string,
  src: PropTypes.any,
};

CircularLoadingIcon.defaultProps = {
  size: Size.XX_LARGE,
  src: FrankLogoSvg,
};
